var app = angular.module("leonardo");

var OnDemandCategoryController = function($scope, $http, $state, $rootScope, categoryObj, ConfigThemeService, ngDialog,
                                          NotificationService, AccountUserService, Upload, OnDemandCategoryService,
                                          FolderFileService, AuthDataService, FormErrorsService, $timeout, AccountService,
                                          FileService, OnDemandSubCategoryService, ClientInstanceService, AttachmentService) {

  $scope.create = $state.current.action === 'create' ;
  $scope.file = null;
  $scope.file_default = null;
  $scope.errorSize = false;
  $scope.category = categoryObj;
  $scope.url_image_default = '';
  $scope.users = [];
  $scope.onDemandSubCategoryService = OnDemandSubCategoryService;
  $scope.accountUserService = AccountUserService;
  $scope.authDataService = AuthDataService;
  //$scope.whiteLabelService = WhiteLabelService;
  $scope.clientInstanceService = ClientInstanceService

  if ($scope.create) {
    $scope.category.client_instance = AuthDataService.getClientInstance();
    if ((AccountService.getCollection().length > 1) && AuthDataService.isNotStaff()) {
      ngDialog.openConfirm({
        template: 'views/templates/dialog/account/select.html',
        controller: 'SelectAccountDialog',
        className: 'ngdialog-theme-default ngdialog-select-account',
        data: {
          permission: 'permission_add_on_demand_category'
        }
      }).then(function (account) {
        if (!account){
          window.history.back();
        }
        $scope.category.account = (account !== 'all') ? account : null;
      }, function() {
        window.history.back();
      });
    }
    else if (AuthDataService.isNotStaff()) {
      $scope.category.account = (categoryObj && categoryObj.account) ? categoryObj.account : AccountUserService.currentAccountUser.account;
    }
    $scope.url_image_default = ConfigThemeService.getLogo('logo1');
    if ($scope.url_image_default) {
      FolderFileService.getFileObject($scope.url_image_default, function (data) {
        var array_url = $scope.url_image_default.split('/');
        var array_filename = array_url[array_url.length - 1].split('.');
        $scope.file_default = new FileService([data], array_url[array_url.length - 1], {type: 'image/' + array_filename[array_filename.length-1], lastModified: new Date()});
        $scope.$apply();
      });
    }
  }
  else {
    if (AuthDataService.isNotStaff()) {
      $scope.category.account = (categoryObj && categoryObj.account) ? categoryObj.account : AccountUserService.currentAccountUser.account;
    }
    $scope.category.client_instance = ($scope.category.client_instance && $scope.category.client_instance.id) ? $scope.category.client_instance.id : $scope.category.client_instance;
    if ($scope.category.subcategories && ($scope.category.subcategories.length > 0)) {
      var subcategories = [];
      angular.forEach($scope.category.subcategories, function(subcategory) {
        subcategories.push(subcategory.id ? subcategory.id : subcategory);
      });
      $scope.category.subcategories = subcategories;
    }
    if($scope.category.image) {
      FolderFileService.getFileObject($scope.category.image, function (fileObject) {
        if (fileObject) {
          var array_url = $scope.category.image.split('/');
          var array_filename = array_url[array_url.length - 1].split('.');
          var type = fileObject.type || 'image/' + array_filename[array_filename.length-1];
          var file = new FileService([fileObject], array_url[array_url.length-1], {type: type});
          $scope.onFileUpload(file, true);
          $scope.$apply();
        }
        else {
          $scope.category.image = null;
          $scope.$apply();
        }
      });
    }
  }

  $scope.onFileUpload = function(file, hideCrop) {
    if (!file) {
      return;
    }
    var svg = file.name ? file.name.split('.svg') : [];
    if (!hideCrop && (svg.length === 1)){
      ngDialog.openConfirm({
        template: 'views/templates/dialog/attachment/image-crop.html',
        className: 'ngdialog-theme-default ngdialog-iframe',
        controller: 'ImageCrop',
        data: {
          file: file
        }
      }).then(function (file_result) {
        $scope.errorSize = AttachmentService.checkErrorSize(file_result);
        if ($scope.errorSize) {
          return;
        }
        $scope.file = file_result;
        $scope.category.image = file_result;
        var formdata = new FormData();
        formdata.append('file', file_result);
        $scope.category.image.file = formdata;
      }, function () {
        return;
      });
    }
    else {
      $scope.errorSize = AttachmentService.checkErrorSize(file);
      if ($scope.errorSize) {
        return;
      }
      $scope.file = $scope.category.image ? angular.copy($scope.category.image) : file;
      $scope.category.image = file;
      var fd = new FormData();
      fd.append('file', file);
      $scope.category.image.file = fd;
    }
  };

  $scope.removeFile = function() {
    $scope.errorSize = false;
    $scope.category.image = null;
    $scope.file = null;
    $scope.file_default = null;
  };

  $scope.getData = function(){
    var data ={
      //white_label: AuthDataService.getWhiteLabel(),
      client_instance: AuthDataService.getClientInstance(),
      description: $scope.category.description || '',
      image: $scope.category.image || '',
      available_for_account_users: $scope.category.available_for_account_users,
      name: $scope.category.name,
      subcategories: !isEmpty($scope.category.subcategories) ? $scope.category.subcategories : []
    };
    if ($scope.category.account) {
      data.account = $scope.category.account;
    }
    return data;
  };

  $scope.submit = function() {
    $scope.Form.$setSubmitted();
    if ($scope.Form.$invalid) {
      FormErrorsService.goToError();
      return;
    }
    if (!$scope.category.image) {
      $scope.onFileUpload($scope.file_default, true);
    }
    if (!angular.isArray($scope.category.available_for_account_users)) {
      $scope.category.available_for_account_users = $scope.category.available_for_account_users ?
        $scope.category.available_for_account_users.split(',') : [];
    }
    var data = $scope.getData();
    if ($scope.create) {
      Upload.upload({
        url: ConfigThemeService.generateURL('/api/2.0/on-demand-categories/'),
        arrayKey: '',
        data: data
      }).then(function(result){
        afterUploadSuccess(result);
      }, function(error) {
        NotificationService.error(error);
      });
    }
    else {
      Upload.upload({
        url: ConfigThemeService.generateURL('/api/2.0/on-demand-categories/' + $scope.category.id + '/'),
        arrayKey: '',
        data: data,
        method: 'PUT'
      }).then(function(result) {
        afterUploadSuccess(result);
      }, function(error) {
        NotificationService.error(error);
      });
    }
  };

  function afterUploadSuccess(result){
    OnDemandCategoryService.updateCollection(result.data);
    $timeout(function () {
      $state.go('on-demand-instructions');
    }, 20);
  }

  $scope.showOnDemandDeleteDialog = function() {
    ngDialog.openConfirm({
      template: 'views/templates/dialog/on-demand-instructions/delete.html',
      controller: 'OnDemandDeleteDialog',
      data: {
        item: $scope.category,
        type: 'category'
      }
    }).then(function() {
      OnDemandCategoryService.updateCollection($scope.category, true);
    }, function () {
      return;
    });
  };

  $scope.$on('on-demand-instruction:updated', function () {
    $state.go('on-demand-instructions.categories');
  });

};

app.controller('OnDemandCategoryController', ['$scope', '$http', '$state', '$rootScope', 'categoryObj',
  'ConfigThemeService', 'ngDialog', 'NotificationService', 'AccountUserService', 'Upload', 'OnDemandCategoryService',
  'FolderFileService', 'AuthDataService', 'FormErrorsService', '$timeout', 'AccountService', 'FileService',
  'OnDemandSubCategoryService', 'ClientInstanceService', 'AttachmentService', OnDemandCategoryController]);
